import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require('./locales/en/translation.json')
        },
        ru: {
            translation: require('./locales/ru/translation.json')
        },
        fr: {
            translation: require('./locales/fr/translation.json')
        },
        ar: {
            translation: require('./locales/ar/translation.json')
        },
        de: {
            translation: require('./locales/de/translation.json')
        }
        // Add other languages as needed
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
